<template>
  <div class="min-h-screen bg-[#efe5d6] overflow-x-hidden">

    <!-- TOP BAR -->

    <!-- <div
      class="
        border-b
        border-[#d9c1aa]
        bg-[#f6edde]
        py-3
        overflow-hidden
      "
    >

      <div
        class="
          whitespace-nowrap
          animate-marquee
          text-[#8f1814]
          font-bold
          tracking-[0.25em]
          text-xs
        "
      >
        BAKE TODAY • HOT ARTICLES • FOOD • DESIGN • LIFESTYLE • CULTURE •
        BAKE TODAY • HOT ARTICLES • FOOD • DESIGN • LIFESTYLE • CULTURE •
      </div>

    </div> -->

    <!-- LOADING -->

    <div v-if="loading" class="max-w-7xl mx-auto px-4 md:px-8 py-16">
      <Skeleton width="120px" height="30px" class="mb-6"/>
      <Skeleton width="70%" height="90px" class="mb-5"/>
      <Skeleton width="40%" height="20px" class="mb-12"/>
      <Skeleton width="100%" height="650px" borderRadius="32px"/>
    </div>

    <article v-else-if="post" class="animate-fadein">

      <section class="max-w-[1700px] mx-auto px-4 md:px-8 py-8">

        <div class="relative overflow-hidden rounded-[38px] min-h-[720px] md:min-h-[900px] shadow-[0_20px_80px_rgba(0,0,0,0.18)]">

          <img :src="post.getPhoto()" :alt="post.title" class="absolute inset-0 h-full w-full object-cover"/>

          <div class="absolute inset-0 bg-gradient-to-t from-black/95 via-black/35 to-black/5"/>
          <div class="relative z-10 flex min-h-[720px] md:min-h-[900px] items-end px-6 py-10 md:px-16 md:py-16">

            <div class="max-w-4xl">

              <div class="flex flex-wrap gap-2">

                <div
                  v-for="tag in post.getTags()"
                  :key="tag"
                  class="rounded-full bg-[#9c1717] px-4 py-2 text-[10px] font-black uppercase tracking-[0.15em] text-white"
                >
                  {{ tag }}
                </div>

              </div>

              <h1 class="mt-8 max-w-[950px] font-['Anton'] uppercase leading-[0.88] text-[#f8f1e7] text-[3.4rem] md:text-[7rem]">
                {{ post.title }}
              </h1>

              <div class="mt-8 flex flex-wrap items-center gap-6 text-white">

                <div class="flex items-center gap-3">

                  <div class="flex h-12 w-12 items-center justify-center rounded-full bg-[#ea6b1d] text-white">
                    <i class="pi pi-user"></i>
                  </div>

                  <div>

                    <p class="text-sm font-bold uppercase tracking-wide">
                      {{ post.getAuthorName() }}
                    </p>

                    <p class="text-xs text-white/70">
                      {{ translate('author', 'ucfirst') }}
                    </p>

                  </div>

                </div>

                <div class="flex items-center gap-2 text-sm text-white/85">
                  <i class="pi pi-calendar"></i>
                  {{ post.getCreatedDate() }}
                </div>

                <div class="flex items-center gap-2 text-sm text-white/85">
                  <i class="pi pi-clock"></i>
                  {{ post.getReadingTime() }} {{ translate('min read', 'ucfirst') }}
                </div>

              </div>

              <div class="mt-10 flex flex-wrap gap-4">

                <Button
                  :label="translate('Back to Blog')"
                  icon="pi pi-arrow-left"
                  @click="urlHandler.redirectAndScroll('/blog/home')"
                  class="!border-none !rounded-full !bg-white !px-7 !py-4 !font-bold !text-[#7e1410]"
                />

                <Button
                  :label="translate('Copy Link')"
                  icon="pi pi-link"
                  @click="copyLink"
                  class="!border-none !rounded-full !bg-white !px-7 !py-4 !font-bold !text-[#7e1410]"
                  outlined
                />

                <Button
                  icon="pi pi-whatsapp"
                  @click="share('wa')"
                  class="!h-14 !w-14 !rounded-full !border-none !bg-blog-red"
                />

              </div>

            </div>

          </div>

        </div>

      </section>

      <section class="relative z-20 mx-auto -mt-20 max-w-5xl px-4 pb-24">

        <div class="rounded-[38px] border border-[#e4ccb3] bg-[#fbf4e8] p-7 md:p-14 shadow-[0_10px_40px_rgba(0,0,0,0.08)]">

          <Editor 
            v-model="post.text" 
            readonly 
            class="blog-editor-view"
          >
            <template #toolbar>
              <span class="hidden"></span>
            </template>
          </Editor>


        </div>

      </section>

    </article>

    <!-- ERROR -->

    <div v-else class="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">

      <i class="pi pi-exclamation-circle text-7xl text-[#d8bca5]"/>

      <h2 class="mt-6 font-['Anton'] text-5xl uppercase text-[#7f140f]">
        {{ translate('post not found', 'ucfirst') }}
      </h2>

      <p class="mt-4 max-w-md text-[#6b4638]">
        {{ translate('The article you are trying to access does not exist anymore.') }}
        
      </p>

      <Button
        :label="translate('Back To Blog')"
        class="mt-8 !rounded-full !border-none !bg-[#e96a1d] !px-8 !py-4"
        @click="urlHandler.redirectAndScroll('/blog/home')"
      />

    </div>

  </div>
</template>

<script setup>

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import Skeleton from 'primevue/skeleton';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';

import BlogPostService from '@/services/BlogPostService';
import Editor from 'primevue/editor';
import 'quill/dist/quill.snow.css';

import urlHandler from '@/composables/urlHandler';
import { showToast } from '@/composables/toast';
import { translate } from '@/composables/translate';

const route = useRoute();
const toast = useToast();

const loading = ref(true);
const post = ref(null);

onMounted(async () => {
  fetchPost(route.params.id);
});

async function fetchPost(id) {

  loading.value = true;

  const blogPostData = await BlogPostService.find(id);

  if (!blogPostData) {

    showToast(
      toast,
      translate('post not found', 'ucfirst'),
      'error'
    );

    urlHandler.redirectAndScroll('/blog');

    return;
  }

  post.value = blogPostData;

  loading.value = false;
}

function copyLink() {

  navigator.clipboard.writeText(
    window.location.href
  );

  showToast(
    toast,
    translate('Link copied successfully!'),
    'success'
  );
}

function share(platform) {

  const url = window.location.href;

  if (platform === 'wa') {

    window.open(
      `https://wa.me/?text=${
        encodeURIComponent(
          post.value.title + ' ' + url
        )
      }`
    );

  }

}

</script>

<style scoped>

.blog-content h2 {
  font-size: 3rem;
  line-height: 1;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
}

.blog-content h3 {
  font-size: 2.2rem;
  line-height: 1;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
}

.blog-content p {
  margin-bottom: 1.7rem;
}

.blog-content ul {
  margin-bottom: 2rem;
}

.blog-content li {
  margin-bottom: 0.7rem;
}

.blog-content img {
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 3rem 0;
}

@keyframes marquee {

  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }

}

.animate-marquee {
  animation: marquee 18s linear infinite;
}

</style>